<template>
	<div class="generic-form">
		<form @submit="submit" novalidate :action="action" method="post">
			<input type="hidden" v-model="request.SessionId" name="SessionId" />

			<div class="d-flex flex-wrap flex-v-start flex-h-between">
				<div class="input-holder">
					<label for="CardHolderName">Name on Card*</label>
					<input type="text" id="CardHolderName" name="CardHolderName" v-model="request.CardHolderName" />
					<small class="p-error" v-if="form.CardHolderName.$error">{{ form.CardHolderName.$errors[0].$message }}</small>
				</div>
			</div>
			<div class="d-flex flex-wrap flex-v-start flex-h-between">
				<div class="input-holder">
					<label for="CardNumber">Card Number*</label>
					<input type="hidden" name="CardNumber" v-model="request.CardNumber" />
					<InputMask id="CardNumber" name="CardNumber" mask="9999 9999 9999 9999" placeholder="1234-5678-9012-3456" v-model="request.CardNumber" />
					<small class="p-error" v-if="form.CardNumber.$error">{{ form.CardNumber.$errors[0].$message }}</small>
				</div>
			</div>
			<div class="d-flex flex-wrap flex-v-start flex-h-between">
				<div class="input-holder">
					<label>Expiry Date*</label>

					<div class="d-flex flex-wrap flex-v-start flex-h-between">
						<div class="input-holder">
							<input type="hidden" name="ExpiryMonth" v-model="request.ExpiryMonth" />
							<Select id="ExpiryMonth" name="ExpiryMonth" v-model="request.ExpiryMonth" :options="expiryMonths" option-value="value" option-label="label" placeholder="Expiry Month" style="width: 100%" />

							<small class="p-error" v-if="form.ExpiryMonth.$error">{{ form.ExpiryMonth.$errors[0].$message }}</small>
						</div>
						<div class="input-holder">
							<input type="hidden" name="ExpiryYear" v-model="request.ExpiryYear" />
							<Select id="ExpiryYear" name="ExpiryYear" v-model="request.ExpiryYear" :options="expiryYears" option-value="value" option-label="label" placeholder="Expiry Year" style="width: 100%" />

							<small class="p-error" v-if="form.ExpiryYear.$error">{{ form.ExpiryYear.$errors[0].$message }}</small>
						</div>
					</div>
				</div>
			</div>
			<div class="d-flex flex-wrap flex-v-start flex-h-between">
				<div class="input-holder">
					<label for="Cvc2">CVC*</label>
					<input type="tel" id="Cvc2" name="Cvc2" v-model="request.Cvc2" />
					<small class="p-error" v-if="form.Cvc2.$error">{{ form.Cvc2.$errors[0].$message }}</small>
				</div>
			</div>

			<div class="form-button">
				<button type="submit" class="btn" :disabled="isSubmitting">Pay Securely Now</button>
			</div>
		</form>
	</div>
</template>
<script lang="ts" setup>
	import useVuelidate from '@vuelidate/core';
	import { helpers, maxLength, numeric, required } from '@vuelidate/validators';
	import { InputMask, Select } from 'primevue';
	import { computed, ref } from 'vue';
	import { PxFusionModel } from './types';

	const props = defineProps({
		action: String,
		sessionId: String,
	});

	const isSubmitting = ref<boolean>(false);

	const expiryMonths = ref(
		Array.from({ length: 12 }, (_, i) => ({
			value: String(i + 1).padStart(2, '0'),
			label: new Date(0, i).toLocaleString('en-US', { month: 'long' }),
		}))
	);

	const currentYear = new Date().getFullYear();
	const expiryYears = ref(
		Array.from({ length: 6 }, (_, i) => ({
			value: String(currentYear + i - 2000).padStart(2, '0'),
			label: currentYear + i,
		}))
	);

	const rules = computed<Partial<Record<keyof PxFusionModel, unknown>>>(() => ({
		SessionId: { required: helpers.withMessage('Required field', required) },
		CardNumber: {
			required: helpers.withMessage('Required field', required),
			maxLength: helpers.withMessage('Too long', maxLength(19)),
		},
		CardHolderName: {
			required: helpers.withMessage('Required field', required),
			maxLength: helpers.withMessage('Too long', maxLength(64)),
		},
		ExpiryMonth: {
			required: helpers.withMessage('Required field', required),
			maxLength: helpers.withMessage('Too long', maxLength(2)),
			numeric: helpers.withMessage('Invalid type', numeric),
		},
		ExpiryYear: {
			required: helpers.withMessage('Required field', required),
			maxLength: helpers.withMessage('Too long', maxLength(2)),
			numeric: helpers.withMessage('Invalid type', numeric),
		},
		Cvc2: {
			cvc2: helpers.withMessage('Invalid cvc2', helpers.regex(/^[0-9]{3,4}$/)),
			required: helpers.withMessage('Required field', required),
			maxLength: helpers.withMessage('Too long', maxLength(4)),
			numeric: helpers.withMessage('Invalid type', numeric),
		},
	}));

	const request = ref<PxFusionModel>(new PxFusionModel({ SessionId: props.sessionId }));
	const form = useVuelidate<PxFusionModel>(rules, request);

	async function submit(e: Event) {
		if (!(await form.value.$validate())) {
			console.log('preventing submit', form.value);
			e.preventDefault();
			return;
		}

		console.log('ok to submit');

		isSubmitting.value = true;
	}
</script>
